import React, { Component } from "react";
import Chart from "react-apexcharts";

export default class LineGraph extends Component {
  render() {
    const { sensor, kleur } = this.props;
    
    // Prepare data for ApexCharts
    function prepareApexData(data) {
      if (!data || !data.data || !Array.isArray(data.data)) return { series: [], categories: [] };
      
      const series = [];
      const categories = [];

      data.data.forEach(function (a) {
        if (a.datum && a.value) {
          series.push([new Date(a.datum).getTime(), parseFloat(a.value)]);
          categories.push(new Date(a.datum).getTime());
        }
      });
      
      return { series, categories };
    }

    const chartData = prepareApexData(sensor || {});
    
    // ApexCharts configuration
    const options = {
      chart: {
        type: 'line',
        height: 300,
        toolbar: {
          show: true,
          tools: {
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true,
            selection: true
          }
        },
        zoom: {
          enabled: true,
          type: 'x',
          autoScaleYaxis: true
        },
        selection: {
          enabled: true,
          type: 'x'
        },
        animations: {
          enabled: false
        }
      },
      colors: [kleur || '#ff3e1d'],
      stroke: {
        curve: 'smooth',
        width: 2
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        type: 'datetime',
        labels: {
          format: 'dd MMM HH:mm',
          datetimeUTC: false
        },
        title: {
          text: 'Datum'
        }
      },
      yaxis: {
        title: {
          text: 'Temperatuur (°C)'
        },
        labels: {
          formatter: function (val) {
            return val.toFixed(1) + '°';
          }
        }
      },
      tooltip: {
        x: {
          format: 'dd MMM yyyy HH:mm'
        },
        y: {
          formatter: function (val) {
            return val.toFixed(1) + "°C";
          }
        }
      },
      grid: {
        borderColor: '#e7e7e7',
        strokeDashArray: 3
      }
    };

    const series = [{
      name: 'Temperatuur',
      data: chartData.series
    }];

    return (
      <div style={{ width: '100%', height: '300px' }}>
        {chartData.series.length > 0 ? (
          <Chart
            options={options}
            series={series}
            type="line"
            height={300}
          />
        ) : (
          <div style={{ 
            height: '300px', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            color: '#666'
          }}>
            Loading Chart...
          </div>
        )}
      </div>
    );
  }
}
